import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import React from "react"
import {FilterExpander} from "../common/FilterExpander";
import PickFilterViewV2 from './PickFilterViewV2'
const PickFilterViewV2Wrapper = () => {
    const {isMobile} = useDeviceLayout()

    return (
        <React.Fragment>
            {isMobile ?
                <FilterExpander>
                    <PickFilterViewV2 />
                </FilterExpander> :
                <PickFilterViewV2 />}
        </React.Fragment>
    )

}
export default PickFilterViewV2Wrapper


// WEBPACK FOOTER //
// ./src/components/pickStatus/PickFilterViewV2Wrapper.js